import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        // The -bg tokens are the org's dedicated pastel tints for badges/
        // alerts (see globals.css) -- the same ones HazmatBadge uses for
        // "Not Yet Classified" / "CURRENT". An opacity modifier on the
        // solid color (bg-success/15 etc.) looks like a different, fainter
        // component next to those, even though it's the same semantic pill.
        default: 'border-transparent bg-primary-100 text-primary',
        muted: 'border-transparent bg-muted text-muted-foreground',
        success: 'border-transparent bg-success-bg text-success',
        warning: 'border-transparent bg-warning-bg text-warning',
        destructive: 'border-transparent bg-destructive-bg text-destructive',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge };
